import * as assemblyEvents from './assembly/assembly-analytics.events'

export const Analytics = {
  assembly: assemblyEvents
}
